<template>
  	<FlexOfflineSubscriptionReport />
</template>

<script>

// @ is an alias to /src
import FlexOfflineSubscriptionReport from "@/components/reports/Flex/OfflineSubscriptionReport.vue";

export default {
  name: "FlexOfflineSubscriptionReportView",
  components: {
    FlexOfflineSubscriptionReport,
  },
};
</script>
